import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const LoginPage = () => { 
  const { t } = useTranslation(); 
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);  // State to toggle password visibility
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`https://learningplatformbc-production.up.railway.app/api/auth/login`, { phone: phone, password: password });
      localStorage.setItem('token', response.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(t('loginPage.errorMessage')); // Use translation for error message
    }
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword); // Toggle show password

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card p-4">
            <h3 className="card-title mb-3">{t('loginPage.title')}</h3>
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleLogin}>
              <div className="form-group mb-3">
                <label htmlFor="phone">{t('loginPage.phoneLabel')}</label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  placeholder={t('loginPage.phonePlaceholder')}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-3">
                <label htmlFor="password">{t('loginPage.passwordLabel')}</label>
                <TextField
                  type={showPassword ? 'text' : 'password'}  // Toggle input type based on showPassword state
                  className="form-control"
                  id="password"
                  placeholder={t('loginPage.passwordPlaceholder')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block">{t('loginPage.loginButton')}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
